import * as React from "react";
import { TimelineItem } from "../timeline-item/timeline-item.mjs";
class Timeline extends React.Component {
  constructor() {
    super(...arguments);
    this.renderContent = () => {
      const { items, children } = this.props;
      if (items) {
        return this.renderItems(items);
      }
      return React.Children.map(children, (item) => {
        if (React.isValidElement(item) && item.type === TimelineItem) {
          return item;
        }
      });
    };
  }
  BEM() {
    const classArray = ["timeline"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  renderItems(items) {
    return items.map((item, index) => /* @__PURE__ */ React.createElement(TimelineItem, { key: index, ...item }));
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.renderContent());
  }
}
export {
  Timeline
};
